import { useSearchChatModeContext } from '@/contexts/SearchChatModeContext';

/**
 * Custom hook to manage the search/chat mode state persistently
 * - Now uses the context provider for proper state sharing across components
 * - Persists mode selection in localStorage
 * - Intelligently sets mode based on current route
 */
export function useSearchChatMode() {
  // Use the context which is now provided at the app level
  return useSearchChatModeContext();
}